import { useContext } from 'react';
import type { TableHTMLAttributes } from 'react';
import { TableScrollContainer, TableScrollContext } from './TableScrollContainer';

export function ResponsiveTable({ children, className = '', ...props }: TableHTMLAttributes<HTMLTableElement>) {
  const hasScrollContainer = useContext(TableScrollContext);
  const table = <table {...props} className={`dt-responsive-table ${className}`}>{children}</table>;

  return hasScrollContainer ? table : <TableScrollContainer>{table}</TableScrollContainer>;
}
